import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from "react";

export function BrandLogo({ src, compact = false }: { src: string; compact?: boolean }) {
  return (
    <a className="brand-logo" href="/" aria-label="DropDex Alerts home">
      <img src={src} alt="" />
      {!compact && <span>DropDex Alerts</span>}
    </a>
  );
}

export function Button({
  children,
  variant = "gold",
  ...props
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "gold" | "ghost" | "green" }>) {
  return (
    <button className={`button button-${variant}`} {...props}>
      {children}
    </button>
  );
}

export function Badge({
  children,
  tone = "gold"
}: PropsWithChildren<{ tone?: "gold" | "green" | "blue" | "muted" }>) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function Panel({
  children,
  className = "",
  title,
  action
}: PropsWithChildren<{ className?: string; title?: string; action?: ReactNode }>) {
  return (
    <section className={`panel ${className}`}>
      {(title || action) && (
        <header className="panel-head">
          {title && <h2>{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

export function Toggle({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className={`toggle ${checked ? "is-on" : ""}`}
      onClick={() => onChange(!checked)}
    >
      <span />
    </button>
  );
}

export function Field({
  label,
  children,
  hint
}: PropsWithChildren<{ label: string; hint?: string }>) {
  return (
    <label className="field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}

export function PlaceholderImage({ label }: { label: string }) {
  return (
    <div className="placeholder-image" aria-label={label}>
      <span className="bolt">ϟ</span>
      <small>{label}</small>
    </div>
  );
}
